import { $campaigns, $currentCampaignList, $promises } from './stores'
import { fetchCampaign, fetchFutureCampaigns } from '@/clients/pops/client'
import { createCampaign } from '@/utilities/factories'
import dayjs from '@/utilities/dayjs-config'

export const loadCampaign = async ({ campaignId }: { campaignId: number }) => {
  if ($campaigns.get()[campaignId]) return Promise.resolve()

  const promiseKey = `loadCampaign${campaignId}`

  if ($promises.get()[promiseKey]) {
    return $promises.get()[promiseKey]
  }

  const promise = (async () => {
    const rawCampaign = await fetchCampaign(campaignId)
    const campaign = createCampaign(rawCampaign)

    if (campaign) {
      $campaigns.setKey(campaignId.toString(), campaign)
    }
  })()

  $promises.setKey(promiseKey, promise)

  return promise
}

export const loadCurrentCampaigns = async () => {
  const lastMonth = dayjs()
    .startOf('month')
    .subtract(1, 'month')
    .format('YYYY-MM-DD')
  const currentCampaigns = await fetchFutureCampaigns(lastMonth)

  currentCampaigns.forEach((rawCampaign) => {
    const campaign = createCampaign(rawCampaign)
    if (campaign) {
      $campaigns.setKey(campaign.id.toString(), campaign)
    }
  })
  // TODO: maybe set model here?
  $currentCampaignList.set(currentCampaigns)
}
